import '@styles/common.less';
import '@styles/layout.less';
import './index.less';
import '@common';

import html2canvas from '@html2canvas';
import LazyLoad from 'vanilla-lazyload';
import MODEL_NUMBERS from './model-numbers';
import STATES from './states';

const baseApi = 'https://ai.virror.net';
// const baseApi = 'http://localhost:8000';
const USE_MOCK_API = false;

const EMAIL_REGEX = /(.+)@(.+){2,}\.(.+){2,}/;
const PHONE_REGEX = /^\d{10}$/;
const VERIFICATION_COOLDOWN_SECONDS = 60;
const POSTAL_CODE_COPY = {
  US: {
    label: 'Zip Code',
    placeholder: 'Zip Code',
    certLabel: 'Zip Code:',
  },
  CA: {
    label: 'Postal Code',
    placeholder: 'Postal Code',
    certLabel: 'Postal Code:',
  },
};

const STATE_COPY = {
  US: {
    label: 'State',
    placeholder: 'State',
    certLabel: 'State:',
  },
  CA: {
    label: 'Province',
    placeholder: 'Province',
    certLabel: 'Province:',
  },
};

function getPostalCodeCopy(country) {
  return country === 'CA' ? POSTAL_CODE_COPY.CA : POSTAL_CODE_COPY.US;
}

function getStateCopy(country) {
  return country === 'CA' ? STATE_COPY.CA : STATE_COPY.US;
}

function getLocalDateString(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function setupInstallationDateInput(input) {
  if (!input) {
    return;
  }

  input.max = getLocalDateString();
  input.addEventListener('input', () => {
    clearFieldError(input.closest('.required-input'));
  });
}

function validateInstallationDate(input) {
  if (!input?.value) {
    return true;
  }

  if (input.value > getLocalDateString()) {
    setFieldError(input.closest('.required-input'), 'Install date cannot be in the future.');
    return false;
  }

  clearFieldError(input.closest('.required-input'));
  return true;
}

function updatePostalCodeLabels(country) {
  const copy = getPostalCodeCopy(country);
  const formLabel = document.querySelector('[data-postal-code-label="form"]');
  const formInput = document.querySelector('input[name="zipcode"]');
  const certLabel = document.querySelector('[data-postal-code-label="cert"]');

  if (formLabel) {
    formLabel.textContent = `${copy.label} *`;
  }

  if (formInput) {
    formInput.placeholder = copy.placeholder;
  }

  if (certLabel) {
    certLabel.textContent = copy.certLabel;
  }
}

function updateStateLabels(country) {
  const copy = getStateCopy(country);
  const formLabel = document.querySelector('[data-state-label="form"]');
  const certLabel = document.querySelector('[data-state-label="cert"]');

  if (formLabel) {
    formLabel.textContent = `${copy.label} *`;
  }

  if (certLabel) {
    certLabel.textContent = copy.certLabel;
  }
}

function populateStateSelect(stateSelect, country, selectedValue = '') {
  const states = STATES[country] || [];
  const copy = getStateCopy(country);

  stateSelect.innerHTML = `<option disabled value="">${copy.placeholder}</option>`;

  states.forEach(({ value, label }) => {
    const option = document.createElement('option');
    option.value = value;
    option.textContent = label;

    if (value === selectedValue) {
      option.selected = true;
    }

    stateSelect.appendChild(option);
  });

  if (!selectedValue) {
    stateSelect.selectedIndex = 0;
  }
}

function getStateLabel(country, stateValue) {
  const state = (STATES[country] || []).find((item) => item.value === stateValue);
  return state ? state.label : stateValue;
}

/**
 * covert canvas to image
 * and save the image file
 */

function canvasToImage () {

	// check if support sth.
	var $support = function () {
		var canvas = document.createElement('canvas'),
			ctx = canvas.getContext('2d');

		return {
			canvas: !!ctx,
			imageData: !!ctx.getImageData,
			dataURL: !!canvas.toDataURL,
			btoa: !!window.btoa
		};
	}();

	var downloadMime = 'image/octet-stream';

	function scaleCanvas (canvas, width, height) {
		var w = canvas.width,
			h = canvas.height;
		if (width == undefined) {
			width = w;
		}
		if (height == undefined) {
			height = h;
		}

		var retCanvas = document.createElement('canvas');
		var retCtx = retCanvas.getContext('2d');
		retCanvas.width = width;
		retCanvas.height = height;
		retCtx.drawImage(canvas, 0, 0, w, h, 0, 0, width, height);
		return retCanvas;
	}

	function getDataURL (canvas, type, width, height, quality) {
		canvas = scaleCanvas(canvas, width, height);
		// JPEG/WebP quality 0–1; omit for PNG (lossless)
		return quality != null ? canvas.toDataURL(type, quality) : canvas.toDataURL(type);
	}

	function saveFile (strData) {
		document.location.href = strData;
	}

	function genImage(strData) {
		var img = document.createElement('img');
		img.src = strData;
		return img;
	}
	function fixType (type) {
		type = type.toLowerCase().replace(/jpg/i, 'jpeg');
		var r = type.match(/png|jpeg|bmp|gif/)[0];
		return 'image/' + r;
	}
	function encodeData (data) {
		if (!window.btoa) { throw 'btoa undefined' }
		var str = '';
		if (typeof data == 'string') {
			str = data;
		} else {
			for (var i = 0; i < data.length; i ++) {
				str += String.fromCharCode(data[i]);
			}
		}

		return btoa(str);
	}
	function getImageData (canvas) {
		var w = canvas.width,
			h = canvas.height;
		return canvas.getContext('2d').getImageData(0, 0, w, h);
	}
	function makeURI (strData, type) {
		return 'data:' + type + ';base64,' + strData;
	}


	/**
	 * create bitmap image
	 * 按照规则生成图片响应头和响应体
	 */
	var genBitmapImage = function (oData) {

		//
		// BITMAPFILEHEADER: http://msdn.microsoft.com/en-us/library/windows/desktop/dd183374(v=vs.85).aspx
		// BITMAPINFOHEADER: http://msdn.microsoft.com/en-us/library/dd183376.aspx
		//

		var biWidth  = oData.width;
		var biHeight	= oData.height;
		var biSizeImage = biWidth * biHeight * 3;
		var bfSize  = biSizeImage + 54; // total header size = 54 bytes

		//
		//  typedef struct tagBITMAPFILEHEADER {
		//  	WORD bfType;
		//  	DWORD bfSize;
		//  	WORD bfReserved1;
		//  	WORD bfReserved2;
		//  	DWORD bfOffBits;
		//  } BITMAPFILEHEADER;
		//
		var BITMAPFILEHEADER = [
			// WORD bfType -- The file type signature; must be "BM"
			0x42, 0x4D,
			// DWORD bfSize -- The size, in bytes, of the bitmap file
			bfSize & 0xff, bfSize >> 8 & 0xff, bfSize >> 16 & 0xff, bfSize >> 24 & 0xff,
			// WORD bfReserved1 -- Reserved; must be zero
			0, 0,
			// WORD bfReserved2 -- Reserved; must be zero
			0, 0,
			// DWORD bfOffBits -- The offset, in bytes, from the beginning of the BITMAPFILEHEADER structure to the bitmap bits.
			54, 0, 0, 0
		];

		//
		//  typedef struct tagBITMAPINFOHEADER {
		//  	DWORD biSize;
		//  	LONG  biWidth;
		//  	LONG  biHeight;
		//  	WORD  biPlanes;
		//  	WORD  biBitCount;
		//  	DWORD biCompression;
		//  	DWORD biSizeImage;
		//  	LONG  biXPelsPerMeter;
		//  	LONG  biYPelsPerMeter;
		//  	DWORD biClrUsed;
		//  	DWORD biClrImportant;
		//  } BITMAPINFOHEADER, *PBITMAPINFOHEADER;
		//
		var BITMAPINFOHEADER = [
			// DWORD biSize -- The number of bytes required by the structure
			40, 0, 0, 0,
			// LONG biWidth -- The width of the bitmap, in pixels
			biWidth & 0xff, biWidth >> 8 & 0xff, biWidth >> 16 & 0xff, biWidth >> 24 & 0xff,
			// LONG biHeight -- The height of the bitmap, in pixels
			biHeight & 0xff, biHeight >> 8  & 0xff, biHeight >> 16 & 0xff, biHeight >> 24 & 0xff,
			// WORD biPlanes -- The number of planes for the target device. This value must be set to 1
			1, 0,
			// WORD biBitCount -- The number of bits-per-pixel, 24 bits-per-pixel -- the bitmap
			// has a maximum of 2^24 colors (16777216, Truecolor)
			24, 0,
			// DWORD biCompression -- The type of compression, BI_RGB (code 0) -- uncompressed
			0, 0, 0, 0,
			// DWORD biSizeImage -- The size, in bytes, of the image. This may be set to zero for BI_RGB bitmaps
			biSizeImage & 0xff, biSizeImage >> 8 & 0xff, biSizeImage >> 16 & 0xff, biSizeImage >> 24 & 0xff,
			// LONG biXPelsPerMeter, unused
			0,0,0,0,
			// LONG biYPelsPerMeter, unused
			0,0,0,0,
			// DWORD biClrUsed, the number of color indexes of palette, unused
			0,0,0,0,
			// DWORD biClrImportant, unused
			0,0,0,0
		];

		var iPadding = (4 - ((biWidth * 3) % 4)) % 4;

		var aImgData = oData.data;

		var strPixelData = '';
		var biWidth4 = biWidth<<2;
		var y = biHeight;
		var fromCharCode = String.fromCharCode;

		do {
			var iOffsetY = biWidth4*(y-1);
			var strPixelRow = '';
			for (var x = 0; x < biWidth; x++) {
				var iOffsetX = x<<2;
				strPixelRow += fromCharCode(aImgData[iOffsetY+iOffsetX+2]) +
							   fromCharCode(aImgData[iOffsetY+iOffsetX+1]) +
							   fromCharCode(aImgData[iOffsetY+iOffsetX]);
			}

			for (var c = 0; c < iPadding; c++) {
				strPixelRow += String.fromCharCode(0);
			}

			strPixelData += strPixelRow;
		} while (--y);

		var strEncoded = encodeData(BITMAPFILEHEADER.concat(BITMAPINFOHEADER)) + encodeData(strPixelData);

		return strEncoded;
	};

	/**
	 * saveAsImage
	 * @param canvasElement
	 * @param {String} image type
	 * @param {Number} [optional] png width
	 * @param {Number} [optional] png height
	 */
	var saveAsImage = function (canvas, width, height, type) {
		if ($support.canvas && $support.dataURL) {
			if (typeof canvas == "string") { canvas = document.getElementById(canvas); }
			if (type == undefined) { type = 'png'; }
			type = fixType(type);
			if (/bmp/.test(type)) {
				var data = getImageData(scaleCanvas(canvas, width, height));
				var strData = genBitmapImage(data);
				saveFile(makeURI(strData, downloadMime));
			} else {
				var strData = getDataURL(canvas, type, width, height);
				saveFile(strData.replace(type, downloadMime));
			}
		}
	};

	var convertToImage = function (canvas, width, height, type) {
		if ($support.canvas && $support.dataURL) {
			if (typeof canvas == "string") { canvas = document.getElementById(canvas); }
			if (type == undefined) { type = 'png'; }
			type = fixType(type);

			if (/bmp/.test(type)) {
				var data = getImageData(scaleCanvas(canvas, width, height));
				var strData = genBitmapImage(data);
				return genImage(makeURI(strData, 'image/bmp'));
			} else {
				var strData = getDataURL(canvas, type, width, height);
				return genImage(strData);
			}
		}
	};



	return {
		saveAsImage: saveAsImage,
		saveAsPNG: function (canvas, width, height) {
			return saveAsImage(canvas, width, height, 'png');
		},
		saveAsJPEG: function (canvas, width, height) {
			return saveAsImage(canvas, width, height, 'jpeg');
		},
		saveAsGIF: function (canvas, width, height) {
			return saveAsImage(canvas, width, height, 'gif');
		},
		saveAsBMP: function (canvas, width, height) {
			return saveAsImage(canvas, width, height, 'bmp');
		},

		convertToImage: convertToImage,
		convertToPNG: function (canvas, width, height) {
			return convertToImage(canvas, width, height, 'png');
		},
		convertToJPEG: function (canvas, width, height) {
			return convertToImage(canvas, width, height, 'jpeg');
		},
		convertToGIF: function (canvas, width, height) {
			return convertToImage(canvas, width, height, 'gif');
		},
		convertToBMP: function (canvas, width, height) {
			return convertToImage(canvas, width, height, 'bmp');
		},
		getDataURL
	};
}

function dataURLToBlob(dataURL) {
    // Decode the base64 string, remove the metadata prefix (data:image/png;base64,)
    const byteString = atob(dataURL.split(',')[1]);

    // Extract the mime type (image/png or whatever it is)
    const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];

    // Write the bytes of the string to a typed array
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
}

function getErrorTextElement(errorMessageEl) {
  return (
    errorMessageEl.querySelector('.error-text')
    || Array.from(errorMessageEl.children).find(
      (el) => !el.classList.contains('error-icon') && !el.classList.contains('relative'),
    )
  );
}

function setFieldError(container, message) {
  const errorEl = container.querySelector('.error-message');
  if (!errorEl) return;

  let textEl = getErrorTextElement(errorEl);
  if (!textEl) {
    textEl = document.createElement('div');
    textEl.className = 'error-text';
    errorEl.appendChild(textEl);
  }
  textEl.textContent = message;
  errorEl.style.display = 'flex';
}

function clearFieldError(container) {
  const errorEl = container.querySelector('.error-message');
  if (errorEl) {
    errorEl.style.display = 'none';
  }
}

function resetErrors(elements) {
  elements.forEach((item) => {
    clearFieldError(item);
  });
}

function getFieldInput(container) {
  if (container.querySelector('input')) {
    return container.querySelector('input');
  }
  if (container.querySelector('select')) {
    return container.querySelector('select');
  }
  return null;
}

function validateRequiredInputs(elements) {
  let valid = true;

  elements.forEach((item) => {
    const targetInput = getFieldInput(item);
    if (!targetInput || targetInput.value) {
      return;
    }

    valid = false;
    setFieldError(item, 'This field is required.');
  });

  return valid;
}

function validateEmailField(container) {
  const targetInput = container.querySelector('input[type="email"], input[name="owner_email"], input[name="email"]')
    || container.querySelector('input');
  const value = targetInput?.value.trim() || '';
  const isRequired = container.classList.contains('required-input');

  if (!value) {
    if (isRequired) {
      setFieldError(container, 'This field is required.');
      return false;
    }

    clearFieldError(container);
    return true;
  }

  if (!EMAIL_REGEX.test(value)) {
    setFieldError(container, 'Please provide valid email address.');
    return false;
  }

  clearFieldError(container);
  return true;
}

function validateEmailInputs(elements) {
  let valid = true;

  elements.forEach((item) => {
    const targetInput = item.querySelector('input[type="email"], input[name="owner_email"], input[name="email"]')
      || item.querySelector('input');
    const value = targetInput?.value.trim() || '';

    // Optional emails (e.g. contractor email): skip when empty
    if (!value) {
      if (!item.classList.contains('required-input')) {
        clearFieldError(item);
      }
      return;
    }

    if (!validateEmailField(item)) {
      valid = false;
    }
  });

  return valid;
}

function bindEmailInputValidation(container) {
  const targetInput = container.querySelector('input[type="email"], input[name="owner_email"], input[name="email"]')
    || container.querySelector('input');
  if (!targetInput) {
    return;
  }

  targetInput.addEventListener('input', () => {
    const value = targetInput.value.trim();

    // Optional field: empty means no validation error
    if (!value && !container.classList.contains('required-input')) {
      clearFieldError(container);
      return;
    }

    if (!value) {
      return;
    }

    validateEmailField(container);
  });
}

function validatePhoneField(container, { required = false } = {}) {
  const targetInput = container.querySelector('input');
  const value = targetInput?.value.trim() || '';
  const isRequired = required || container.classList.contains('required-input');

  if (!value) {
    if (isRequired) {
      setFieldError(container, 'This field is required.');
      return false;
    }

    clearFieldError(container);
    return true;
  }

  if (!PHONE_REGEX.test(value)) {
    setFieldError(container, 'Please enter a 10-digit phone number.');
    return false;
  }

  clearFieldError(container);
  return true;
}

function validatePhoneInputs(elements) {
  let valid = true;

  elements.forEach((item) => {
    const targetInput = item.querySelector('input');
    const value = targetInput?.value.trim() || '';

    // Empty required fields are handled by validateRequiredInputs on submit
    if (!value) {
      return;
    }

    if (!validatePhoneField(item)) {
      valid = false;
    }
  });

  return valid;
}

function bindPhoneInputValidation(container) {
  const targetInput = container.querySelector('input');
  if (!targetInput) {
    return;
  }

  targetInput.addEventListener('input', () => {
    // Keep only digits so live validation stays aligned with the 10-digit rule
    const digitsOnly = targetInput.value.replace(/\D/g, '').slice(0, 10);
    if (targetInput.value !== digitsOnly) {
      targetInput.value = digitsOnly;
    }

    // While typing: empty clears format error; incomplete/invalid shows format error
    if (!digitsOnly) {
      clearFieldError(container);
      return;
    }

    validatePhoneField(container);
  });
}

function validateRadioGroup(form, name) {
  const radio = form.querySelector(`input[name="${name}"]`);
  if (!radio) {
    return true;
  }

  const container = radio.closest('.product-type-radio');
  const checked = form.querySelector(`input[name="${name}"]:checked`);

  if (checked) {
    return true;
  }

  if (container) {
    setFieldError(container, 'This field is required.');
  }

  return false;
}

function resetRadioGroupErrors(form) {
  form.querySelectorAll('.product-type-radio .error-message').forEach((errorEl) => {
    errorEl.style.display = 'none';
  });
}

function hideHintMessage(container) {
  const hintEl = container.querySelector('.hint-message');
  if (hintEl) {
    hintEl.style.display = 'none';
  }
}

function showHintMessage(container) {
  const hintEl = container.querySelector('.hint-message');
  if (hintEl) {
    hintEl.style.display = 'flex';
  }
}

function validateForm(form) {
  resetErrors(form.querySelectorAll('.required-input, .email-input, .phone-input'));
  resetRadioGroupErrors(form);

  let valid = validateRequiredInputs(form.querySelectorAll('.required-input'));
  valid = validateEmailInputs(form.querySelectorAll('.email-input')) && valid;
  valid = validatePhoneInputs(form.querySelectorAll('.phone-input')) && valid;

  return valid;
}

function validateOwnerEmailField(emailContainer) {
  clearFieldError(emailContainer);
  hideHintMessage(emailContainer);

  const emailInput = emailContainer.querySelector('input[name="owner_email"]');
  if (!emailInput) {
    return false;
  }

  if (!emailInput.value) {
    setFieldError(emailContainer, 'This field is required.');
    return false;
  }

  if (!EMAIL_REGEX.test(emailInput.value.trim())) {
    setFieldError(emailContainer, 'Please provide valid email address.');
    return false;
  }

  return true;
}

async function checkSerialNumbers(payload) {
  if (USE_MOCK_API) {
    console.log('[mock] checkSerialNumbers', payload);

    return {
      success: true,
      result: payload.numbers.map(() => ({
        success: true,
        category: 'AC',
      })),
    };
  }

  const response = await fetch(`${baseApi}/midea-serial-number`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return response.json();
}

async function sendVerificationCode(email) {
  if (USE_MOCK_API) {
    console.log('[mock] sendVerificationCode', email);
    return { success: true };
  }

  const response = await fetch(`${baseApi}/request-code`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  return response.json();
}

async function submitRegistration(payload) {
  if (USE_MOCK_API) {
    console.log('[mock] submitRegistration', payload);

    return {
      success: true,
      data: {
        warranty_number: 'WR-000000',
      },
    };
  }

  const response = await fetch(`${baseApi}/midea-registration-new`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return response.json();
}

async function generateCertificateImage(payload, warrantyNumber) {
  const certWrapper = document.getElementById('cert-wrapper');
  const certResult = document.getElementById('cert-result');
  const certHint = document.getElementById('cert-hint');

  if (!certWrapper || !certResult) {
    throw new Error('Certificate layout is not available.');
  }

  populateCertificateData(payload, warrantyNumber);
  updatePostalCodeLabels(payload.country);
  updateStateLabels(payload.country);

  window.scrollTo({
    top: 0,
  })

  const rect = certWrapper.getBoundingClientRect();
  // scale > devicePixelRatio 才能导出高清图；最终勿再缩回 CSS 像素尺寸
  const exportScale = Math.max(3, Math.ceil(window.devicePixelRatio || 1) * 2);
  const canvas = await html2canvas(certWrapper, {
    allowTaint: false,
    useCORS: true,
    backgroundColor: null,
    imageTimeout: 1000,
    scale: exportScale,
    width: rect.width,
    height: rect.height,
    x: rect.left,
    y: rect.top,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
  });

  const c2i = canvasToImage();
  // 保留 html2canvas 生成的高分辨率（canvas.width ≈ rect.width * scale）
  const imageUrl = c2i.getDataURL(canvas, 'image/jpeg', canvas.width, canvas.height, 0.95);
  certResult.src = imageUrl;

  const formData = new FormData();
  formData.append('warranty_number', warrantyNumber);
  formData.append('image', dataURLToBlob(imageUrl), 'image.jpg');

  if (USE_MOCK_API) {
    console.log('[mock] uploadCertificateImage', warrantyNumber);

    if (certHint) {
      certHint.style.display = 'none';
    }

    return { success: true };
  }

  const response = await fetch(`${baseApi}/midea-cert-upload`, {
    method: 'POST',
    body: formData,
  });
  const data = await response.json();

  if (certHint) {
    certHint.style.display = 'none';
  }

  return data;
}

function populateCertificateData(payload, warrantyNumber) {
  const certWrapper = document.getElementById('cert-wrapper');
  if (!certWrapper) {
    return;
  }

  certWrapper.querySelector('.value-0').textContent = warrantyNumber;
  certWrapper.querySelector('.value-1').textContent = payload.owner_name;
  certWrapper.querySelector('.value-2').textContent = payload.address;
  certWrapper.querySelector('.value-3').textContent = payload.city;
  certWrapper.querySelector('.value-4').textContent = payload.state;
  certWrapper.querySelector('.value-5').textContent = payload.zipcode;
  certWrapper.querySelector('.value-6').textContent = payload.name;
  certWrapper.querySelector('.value-7').textContent = payload.installation_date;

  const formValue1 = certWrapper.querySelector('.form-value-1');
  const formValue2 = certWrapper.querySelector('.form-value-2');

  formValue1.innerHTML = '';
  formValue2.innerHTML = '';

  payload.numbers.forEach((item) => {
    const modelRow = document.createElement('div');
    modelRow.textContent = item.model_name;
    formValue1.appendChild(modelRow);

    const serialRow = document.createElement('div');
    serialRow.textContent = item.serial_number;
    formValue2.appendChild(serialRow);
  });
}

const NUMBER_ERROR_DEFAULT = 'The Information You Entered Is Incorrect, Please Reenter';
const MODEL_SUGGESTION_LIMIT = 10;

function searchModelNumbers(query) {
  const normalized = query.trim().toLowerCase();
  if (!normalized) {
    return [];
  }

  return MODEL_NUMBERS.filter((model) => model.toLowerCase().includes(normalized))
    .slice(0, MODEL_SUGGESTION_LIMIT);
}

function hideModelSuggestions(suggestionsEl) {
  suggestionsEl.innerHTML = '';
  suggestionsEl.style.display = 'none';
}

function showModelSuggestions(input, suggestionsEl, matches) {
  suggestionsEl.innerHTML = '';

  if (!matches.length) {
    suggestionsEl.style.display = 'none';
    return;
  }

  matches.forEach((model) => {
    const item = document.createElement('button');
    item.type = 'button';
    item.className = 'model-suggestion-item';
    item.textContent = model;
    item.addEventListener('mousedown', (event) => {
      event.preventDefault();
      input.value = model;
      hideModelSuggestions(suggestionsEl);
    });
    suggestionsEl.appendChild(item);
  });

  suggestionsEl.style.display = 'block';
}

function initModelAutocomplete(container) {
  const input = container.querySelector('.model-input');
  const suggestionsEl = container.querySelector('.model-suggestions');

  if (!input || !suggestionsEl) {
    return;
  }

  const updateSuggestions = () => {
    showModelSuggestions(input, suggestionsEl, searchModelNumbers(input.value));
  };

  input.addEventListener('input', updateSuggestions);
  input.addEventListener('focus', updateSuggestions);
  input.addEventListener('blur', () => {
    window.setTimeout(() => hideModelSuggestions(suggestionsEl), 150);
  });
}

function buildNumberRowTemplate(index) {
  return `
    <div class="w-full number-row">
      <div class="w-full flex number-row-wrapper">
        <div class="model-number-field">
          <div class="model-input-wrapper">
            <div class="number-label font-m number-label-1">Model Number *</div>
            <div class="model-autocomplete-wrapper required-input">
              <input
                class="font-pro-r model-input model-select"
                name="model-input-${index}"
                type="text"
                autocomplete="off"
                placeholder="Type Model Number Here"
              />
              <div class="model-suggestions"></div>
              <div class="error-message">
                <div class="relative error-icon">
                  <img class="bg-img-contain" src="./images/home/wrong.png" />
                </div>
                <div class="error-text">This field is required</div>
              </div>
            </div>
          </div>
        </div>

        <div class="number-value-fields">
          <div>
            <div class="number-label font-m number-label-2">Serial Number *</div>
          </div>
          <div class="serial-input-wrapper required-input">
            <input
              class="font-pro-r serial-input"
              name="serial-number-${index}"
              type="text"
              required
              placeholder="Type The Serial Number/Factory Code Here"
            />
            <div class="error-message">
              <div class="relative error-icon">
                <img class="bg-img-contain" src="./images/home/wrong.png" />
              </div>
              <div class="error-text">This field is required</div>
            </div>
          </div>
        </div>
      </div>
      <div class="number-error">
        <div class="relative error-icon">
          <img class="bg-img-contain" src="./images/home/wrong.png" />
        </div>
        <div class="number-error-text">${NUMBER_ERROR_DEFAULT}</div>
      </div>
      <div class="delete-button">Delete</div>
    </div>
  `;
}

function showNumberError(row, message) {
  const numberError = row.querySelector('.number-error');
  if (!numberError) return;

  const textEl = numberError.querySelector('.number-error-text')
    || Array.from(numberError.children).find(
      (el) => !el.classList.contains('error-icon') && !el.classList.contains('relative'),
    );

  if (textEl) {
    textEl.textContent = message || NUMBER_ERROR_DEFAULT;
  }

  numberError.style.display = 'flex';
}

function hideNumberErrors(form) {
  form.querySelectorAll('.number-error').forEach((item) => {
    item.style.display = 'none';
  });
}

function collectNumberRows(form) {
  const rows = form.querySelectorAll('.number-row');
  const checkData = [];

  rows.forEach((row, index) => {
    const modelInput = row.querySelector('.model-input, .model-select');
    const serialInput = row.querySelector('.serial-input');

    if (!modelInput || !serialInput) {
      return;
    }

    checkData.push({
      model_name: modelInput.value.trim(),
      serial_number: serialInput.value.trim(),
      position: index,
    });
  });

  return checkData;
}

function bindNumberRow(row, onDelete) {
  const deleteButton = row.querySelector('.delete-button');
  const modelAutocomplete = row.querySelector('.model-autocomplete-wrapper');

  deleteButton.addEventListener('click', onDelete);

  if (modelAutocomplete) {
    initModelAutocomplete(modelAutocomplete);
  }
}

function initRegistrationForms() {
  const form1 = document.getElementById('form-1');
  const form2 = document.getElementById('form-2');
  const result = document.getElementById('result');
  const addButton = document.getElementById('add-button');
  const numberContainer = form1.querySelector('.number-container');
  const sendCodeButton = document.getElementById('send-code-button');
  const ownerEmailContainer = form2.querySelector('.email-input');
  const installationDateInput = form1.querySelector('input[name="installation_date"]');

  setupInstallationDateInput(installationDateInput);

  let currentRowIndex = 1;
  let submittingForm1 = false;
  let submittingForm2 = false;
  let generatingCertificate = false;
  let verificationCooldownTimer = null;
  let verificationCooldownRemaining = 0;

  const deleteNumberRow = (row) => {
    if (form1.querySelectorAll('.number-row').length <= 1) {
      window.alert('Cannot delete the only row.');
      return;
    }

    row.remove();
  };

  form1.querySelectorAll('.number-row').forEach((row) => {
    bindNumberRow(row, () => deleteNumberRow(row));
  });

  addButton.addEventListener('click', () => {
    currentRowIndex += 1;

    const wrapper = document.createElement('div');
    wrapper.innerHTML = buildNumberRowTemplate(currentRowIndex).trim();
    const newRow = wrapper.firstElementChild;

    numberContainer.appendChild(newRow);
    bindNumberRow(newRow, () => deleteNumberRow(newRow));
  });

  const startVerificationCooldown = () => {
    verificationCooldownRemaining = VERIFICATION_COOLDOWN_SECONDS;
    sendCodeButton.classList.add('disabled');
    sendCodeButton.textContent = `Resend in ${verificationCooldownRemaining}s`;

    verificationCooldownTimer = window.setInterval(() => {
      verificationCooldownRemaining -= 1;

      if (verificationCooldownRemaining <= 0) {
        window.clearInterval(verificationCooldownTimer);
        verificationCooldownTimer = null;
        sendCodeButton.classList.remove('disabled');
        sendCodeButton.textContent = 'Get verification code';
        return;
      }

      sendCodeButton.textContent = `Resend in ${verificationCooldownRemaining}s`;
    }, 1000);
  };

  sendCodeButton.addEventListener('click', async () => {
    if (verificationCooldownRemaining > 0) {
      return;
    }

    if (!validateOwnerEmailField(ownerEmailContainer)) {
      return;
    }

    const ownerEmail = ownerEmailContainer.querySelector('input[name="owner_email"]').value;

    try {
      const data = await sendVerificationCode(ownerEmail);

      if (!data.success) {
        setFieldError(ownerEmailContainer, data.message || 'Failed to send verification code.');
        return;
      }

      showHintMessage(ownerEmailContainer);
      startVerificationCooldown();
    } catch (error) {
      console.error('[sendVerificationCode]', error);
      setFieldError(ownerEmailContainer, 'Failed to send verification code. Please try again.');
    }
  });

  ownerEmailContainer.querySelector('input[name="owner_email"]').addEventListener('input', () => {
    clearFieldError(ownerEmailContainer);
    hideHintMessage(ownerEmailContainer);
  });

  form2.querySelectorAll('.phone-input').forEach((container) => {
    bindPhoneInputValidation(container);
  });

  // Contractor email is optional: only validate format when the user enters a value
  const contractorEmailContainer = form2.querySelector('input[name="email"]')?.closest('.email-input');
  if (contractorEmailContainer) {
    bindEmailInputValidation(contractorEmailContainer);
  }

  const countrySelect = form2.querySelector('select[name="country"]');
  const stateSelect = form2.querySelector('select[name="state"]');

  countrySelect.addEventListener('change', () => {
    updatePostalCodeLabels(countrySelect.value);
    updateStateLabels(countrySelect.value);
    populateStateSelect(stateSelect, countrySelect.value);
  });

  populateStateSelect(stateSelect, countrySelect.value);
  updatePostalCodeLabels(countrySelect.value);
  updateStateLabels(countrySelect.value);

  form1.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (submittingForm1) {
      return;
    }

    resetErrors(form1.querySelectorAll('.required-input'));
    resetRadioGroupErrors(form1);
    hideNumberErrors(form1);

    let valid = validateRequiredInputs(form1.querySelectorAll('.required-input'));
    valid = validateRadioGroup(form1, 'type_of_purchase') && valid;
    valid = validateRadioGroup(form1, 'application_type') && valid;
    valid = validateRadioGroup(form1, 'registered_by') && valid;
    valid = validateInstallationDate(installationDateInput) && valid;

    if (!valid) {
      return;
    }

    const checkData = collectNumberRows(form1);
    const payload = { numbers: checkData };

    submittingForm1 = true;

    try {
      const data = await checkSerialNumbers(payload);
      submittingForm1 = false;

      if (!data.success) {
        window.alert('Please provide Model Number and Serial Number.');
        return;
      }

      const hasInvalidRow = data.result.some((item) => !item.success);

      if (hasInvalidRow) {
        const numberRows = form1.querySelectorAll('.number-row');

        data.result.forEach((item, index) => {
          if (item.success) {
            return;
          }

          const rowIndex = checkData[index]?.position ?? index;
          const row = numberRows[rowIndex];

          if (row) {
            showNumberError(row, item.message);
          }
        });

        return;
      }

      form1.style.display = 'none';
      form2.style.display = 'block';
      form2.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (error) {
      submittingForm1 = false;
      console.error('[checkSerialNumbers]', error);
      window.alert('Submit failed, please try again later.');
    }
  });

  form2.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (submittingForm2 || generatingCertificate) {
      return;
    }

    let valid = validateForm(form2);

    if (!valid) {
      return;
    }

    const form1Data = collectNumberRows(form1);
    const payload = {
      installation_date: form1.querySelector('input[name="installation_date"]').value,
      type_of_purchase: form1.querySelector('input[name="type_of_purchase"]:checked').value,
      application_type: form1.querySelector('input[name="application_type"]:checked').value,
      registered_by: form1.querySelector('input[name="registered_by"]:checked').value,
      numbers: form1Data,
      owner_name: form2.querySelector('input[name="owner_name"]').value,
      owner_phone: form2.querySelector('input[name="owner_phone"]').value,
      owner_email: form2.querySelector('input[name="owner_email"]').value,
      owner_code: form2.querySelector('input[name="owner_code"]').value,
      country: form2.querySelector('select[name="country"]').value,
      state: getStateLabel(
        form2.querySelector('select[name="country"]').value,
        form2.querySelector('select[name="state"]').value,
      ),
      city: form2.querySelector('input[name="city"]').value,
      zipcode: form2.querySelector('input[name="zipcode"]').value,
      address: form2.querySelector('input[name="address"]').value,
      contractor: form2.querySelector('input[name="contractor"]').value,
      phone: form2.querySelector('input[name="phone"]').value,
      name: form2.querySelector('input[name="name"]').value,
      email: form2.querySelector('input[name="email"]').value,
      address2: form2.querySelector('input[name="address2"]').value,
    };

    submittingForm2 = true;

    try {
      const data = await submitRegistration(payload);
      submittingForm2 = false;

      if (!data.success) {
        window.alert(data.message || data.msg || 'Submit failed, please try again later.');
        return;
      }

      form2.style.display = 'none';
      result.style.display = 'block';

      const certHint = document.getElementById('cert-hint');
      if (certHint) {
        certHint.style.display = 'block';
      }

      result.scrollIntoView({ behavior: 'smooth', block: 'start' });

      generatingCertificate = true;

      try {
        await generateCertificateImage(payload, data.data.warranty_number);
      } finally {
        generatingCertificate = false;
      }
    } catch (error) {
      submittingForm2 = false;
      generatingCertificate = false;
      console.error('[submitRegistration]', error);
      window.alert('Submit failed, please try again later.');
    }
  });

  window.addEventListener('beforeunload', (event) => {
    if (generatingCertificate) {
      event.preventDefault();
      event.returnValue = 'Generating your certificate… This may take a few minutes.';
      return event.returnValue;
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  new LazyLoad({
    elements_selector: '.lazy',
    threshold: 300,
  });

  const exampleContainer = document.getElementById('example-container');
  const exampleToggle = document.getElementById('example-toggle');
  let exampleOpen = false;

  exampleToggle.addEventListener('click', () => {
    exampleOpen = !exampleOpen;
    exampleContainer.style.display = exampleOpen ? 'flex' : 'none';
  });

  initRegistrationForms();
});
